import type { TOC } from '@ember/component/template-only'
import DisabledFeaturesAlert from 'district-ui-client/components/integrations/disabled-features-alert'
import { PageTitle } from 'district-ui-client/components/page-title'

interface Signature {
  Element: HTMLDivElement
  Blocks: {
    default: []
  }
}

export const ManageHeading: TOC<Signature> = <template>
  <PageTitle ...attributes>
    {{yield}}
  </PageTitle>
  <DisabledFeaturesAlert />
</template>

export default ManageHeading
